import { SchoolService, BaseService } from "@/services/school.service";

const OutcomeService = {
    getPrivate(subjectId) {
        return SchoolService.getAll("outcomes/subject/" + subjectId +"?visibility=private&state=all")
    },

    getByCourse(courseId, type, includes) {
    	let endpoint = type == 'custom' ? 'outcomes?visibility=member&state=open' : 'outcomes?visibility=public&state=open'
        let withIncludes = includes === true ? "&include=years,courses" : ""
        return SchoolService.getAll("courses/" + courseId + "/" + endpoint + withIncludes)
    },

    add(payload) {
        return SchoolService.create("outcomes", payload)
    },

    update(object, identifier) {
        return SchoolService.update("outcomes", identifier, object)
    },

    // GRADES
    addGrade(payload) {
    	return SchoolService.create("outcomegrades", payload)
    },

    updateGrade(result) {
    	return SchoolService.update("outcomegrades", result.identifier, result)
    },


    deleteGrade(result) {
    	return SchoolService.delete("outcomegrades", result.identifier, null)
    },

    getCourseGrades(courseId) {
    	return SchoolService.getAll("courses/" + courseId + "/outcomegrades")
    }

     
}

export { OutcomeService };